import { render } from "./AddToBlackList.vue?vue&type=template&id=a0daea66"
import script from "./AddToBlackList.vue?vue&type=script&lang=js"
export * from "./AddToBlackList.vue?vue&type=script&lang=js"

import "./AddToBlackList.vue?vue&type=style&index=0&id=a0daea66&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__